export enum CustomerType {
  Unknown = 'Unknown',
  Starter = 'Starter',
  Mover = 'Mover'
}

export enum CustomerAabType {
  HasMortgage = 'HasMortgage',
  HasNoMortgage = 'HasNoMortgage'
}
